import { GameId } from '@bg-shared/enums/GameId';
import {
    ICardGameRunItemSixPlusPoker,
    IMappedRunItemCallback,
} from '@bg-shared/business/CurrentResult/interfaces';
import { SixPlusPokerDealtTo } from '@bg-shared/enums/SixPlusPokerDealtTo';
import { SIX_PLUS_POKER_CARD_COUNTS } from '@bg-shared/constants/constants';
import { useCurrentResult } from './useCurrentResult';

const positionsMap: Record<SixPlusPokerDealtTo, number> = {
    [SixPlusPokerDealtTo.PLAYER]: 0,
    [SixPlusPokerDealtTo.BOARD]: SIX_PLUS_POKER_CARD_COUNTS.PLAYER,
    [SixPlusPokerDealtTo.DEALER]:
        SIX_PLUS_POKER_CARD_COUNTS.PLAYER + SIX_PLUS_POKER_CARD_COUNTS.TABLE,
};

const mapData: IMappedRunItemCallback<ICardGameRunItemSixPlusPoker> = (entry) => {
    const item = entry.item as ICardGameRunItemSixPlusPoker;

    return {
        item,
        // order is different in 6+ Poker: 1..2 (dealer), 1..5 (board), 1..2 (player)
        // mapping positions from 1 to 9
        order: item.position + positionsMap[item.dealtTo],
    };
};

export const useCurrentCardResultSixPlusPoker = (
    drawCode: string,
    delay = 0,
): ICardGameRunItemSixPlusPoker[] =>
    useCurrentResult<ICardGameRunItemSixPlusPoker>(GameId.SIX_PLUS_POKER, drawCode, delay, mapData);
